import { parseISO } from 'date-fns';
import { format } from 'date-fns/esm';
import { useEffect, useState } from 'react';
import { ARROWDOWN_ICON } from '../../../../assets/icons';
import { DropDownItem, Dropdown, MenuProps } from '../../../../components/DropDown';
import ModalContainer, { ConfirmationBox } from '../../../../components/Modal';
import { TableRowItemData } from '../../../../components/Table';
// import { updateStudent } from '../../../../reducers/studentsSlice';
import { useQueryClient } from '@tanstack/react-query';
import { IStudent } from '@wot/typings';
import { toast } from 'react-toastify';
import studentsApi from '../../../../api/students';

export function TableRowItem({ student, setStudent }: { student: IStudent, setStudent?: any }) {
  const [statusOptions, setStatusOptions] = useState<MenuProps[]>([]);
  const queryClient = useQueryClient();

  const sendToBlock = () => {
    studentsApi
      .updateStudent(student._id, {
        status: 'block'
      })
      .then(() => {
        setStudent && setStudent({ ...student, status: "block" })
        queryClient.invalidateQueries({ queryKey: ['students'] });
        toast.success(`${student.name} blocked`);
      })
      .catch(() => {
        toast.error(`Something went wrong.`);
      });
  };

  const sendToActive = () => {
    studentsApi
      .updateStudent(student._id, {
        status: 'active'
      })
      .then(() => {
        setStudent && setStudent({ ...student, status: "active" })
        queryClient.invalidateQueries({ queryKey: ['students'] });
        toast.success(`${student.name} Activated`);
      })
      .catch(() => {
        toast.error(`Something went wrong.`);
      });
  };

  useEffect(() => {
    let items: MenuProps[] = [];
    if (student.status === 'active') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Blocked?" onConfirm={() => sendToBlock()} />}
            >
              <DropDownItem label="Block" />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }

    if (student.status === 'block') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Active?" onConfirm={() => sendToActive()} />}
            >
              <DropDownItem label="Active" />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }
  }, [student.status]);

  return (
    <>
      <TableRowItemData text={format(parseISO(student.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={student._id} />
      <TableRowItemData text={student.name} />
      <TableRowItemData text={student.email} />
      <TableRowItemData text={student.phoneNumber} />
      <TableRowItemData
        component={
          <div className="w-full flex items-center justify-between">
            <Dropdown menu={statusOptions} placement="bottomLeft">
              <div
                className={`${student.status === 'active' ? 'bg-[#D2FFC7] text-[#498839]' : ''} ${student.status === 'block' ? 'bg-[#E9EDF5] text-[#5A6376]' : ''
                  } w-full flex items-center justify-between gap-4 px-4 py-1 rounded-full cursor-pointer`}
              >
                <p className="text-sm font-semibold">{student.status}</p>
                <img src={ARROWDOWN_ICON} alt="Open status menu" className={`w-4`} />
              </div>
            </Dropdown>
          </div>
        }
      />
    </>
  );
}

// ${status === "under-review" && "bg-[#FFE1C9] text-[#BA5300]"}
// ${status === "revision" && "bg-[#DAFDFF] text-[#006B72] "}
// ${status === "gen-agreement" && "bg-[#E9EDF5] text-[#5A6376]"}
// ${status === "rev-agreement" && "bg-[#EEFCE0] text-[#498839]"}
// ${status === "rejected" && "bg-[#EEFCE0] text-[#498839]"}
